import { MeetingProfile } from "./pages/meetingProfile";
import { MeetingLobby } from "./pages/meetingLobby";
import { Products } from "./pages/products";
import { MeetingCall } from "./pages/meetingCall";
import { MeetingEnded } from "./pages/meetingEnded";
import { MeetingCancelled } from './pages/meetingCancelled';

export default {
  products: {
    name: "products",
    component: Products,
    url: "/corp/:corpId/products",
    exact: false,
  },
  profile: {
    name: "profile",
    component: MeetingProfile,
    url: "/virtual-meet/profile/:uuid", // when changing this adapt in src/profile/profile.tsx as well
    exact: false,
  },
  lobby: {
    name: "lobby",
    component: MeetingLobby,
    url: "/virtual-meet/lobby/:uuid",
    exact: false,
  },
  call: {
    name: "call",
    component: MeetingCall,
    url: "/virtual-meet/call/:uuid",
    exact: false,
  },
  summary: {
    name: "summary",
    component: MeetingEnded,
    url: "/virtual-meet/ended/:uuid",
    exact: false,
  },
  cancel: {
    name: "cancel",
    component: MeetingCancelled,
    url: "/virtual-meet/cancel/:uuid",
    exact: false,
  }
};
